import { MODULES } from "shared/config";
import * as yup from "yup";

const getDsvEmailValidationSchema = (emailOwner) =>
  yup
    .string()
    .required(`${emailOwner} e-mail address is required.`)
    .email("Must be a valid e-mail address.")
    .matches(
      /(^[A-Za-z0-9._%+-@]+dsv\.com$)/i,
      "E-mail address must belong to one of DSV domains."
    );

export const getCardHolderAddValidationSchema = (moduleName) =>
  yup.object({
    card_holder_email: getDsvEmailValidationSchema("Card Holder"),
    responsible_person_email: yup
      .string()
      .when((_, schema) =>
        moduleName !== MODULES.CORPORATE_CARDS
          ? getDsvEmailValidationSchema("Responsible person")
          : schema.notRequired().nullable()
      ),
    supervisor_email: yup
      .string()
      .when((_, schema) =>
        moduleName !== MODULES.CORPORATE_CARDS
          ? getDsvEmailValidationSchema("Supervisor")
          : schema.notRequired().nullable()
      ),
    card_holder_name: yup
      .string()
      .when((_, schema) =>
        moduleName === MODULES.CORPORATE_CARDS
          ? schema
              .min(1, "Card holder name must be longer than 1 character.")
              .max(
                255,
                "Card holder name must be not longer than 255 characters."
              )
              .required("Card holder name is required.")
          : schema.notRequired().nullable()
      ),
  });

export const getCardHolderEditValidationSchema = (moduleName) =>
  yup.object({
    responsible_person_email: yup
      .string()
      .when((_, schema) =>
        moduleName !== MODULES.CORPORATE_CARDS
          ? getDsvEmailValidationSchema("Responsible person")
          : schema.notRequired().nullable()
      ),
    supervisor_email: yup
      .string()
      .when((_, schema) =>
        moduleName !== MODULES.CORPORATE_CARDS
          ? getDsvEmailValidationSchema("Supervisor")
          : schema.notRequired().nullable()
      ),
  });
